module.exports = "pegasus_template/assets/square-instagram.png";